<template>
  <div class="tagger">
    <div>
      <ux-pill
        icon="fa-tag"
        @click="removeTag(tag)"
        :value="tag"
        v-for="tag in model"
        deleteable
      />
    </div>
    <content-search
      :list="false"
      ref="search"
      :create-enabled="createEnabled"
      @create="handleCreate"
      type="tag"
      v-model:search="keywords"
      v-model="model"
      placeholder="Type to search or create a new tag"
      multiple
    />
    <div class="pills">
      <ux-spinner v-if="loadingRecent" />
      <template v-else-if="filteredRecentTags.length">
        <h5>Recently used tags</h5>
        <ux-pill
          icon="fa-tag"
          v-for="(tag, index) in filteredRecentTags"
          :key="tag._id"
          :value="tag"
          @click="addTag(tag)"
        />
      </template>
    </div>
  </div>
</template>
<script>
import Search from "../form/inputs/search.vue";
import ContentSearch from "../form/inputs/content-search.vue";

export default {
  components: {
    Search,
    ContentSearch,
  },
  methods: {
    async handleCreate(title) {
      const self = this;

      const result = await self.$sdk.global.create("tag", {
        model: {
          title,
        },
      });

      const newModel = [...this.model, result];
      this.model = newModel;
    },
    removeTag(tag) {
      const index = this.model.indexOf(tag);
      if (index > -1) {
        const newModel = [...this.model];
        newModel.splice(index, 1);
        this.model = newModel;
      }
    },
    addTag(tag) {
      // Check if tag is already in the model to avoid duplicates
      const exists = this.model.some(
        (existingTag) => existingTag._id === tag._id,
      );
      if (!exists) {
        const newModel = [...this.model, tag];
        this.model = newModel;
      }
    },
    async fetchRecentTags() {
      try {
        this.loadingRecent = true;
        const response = await this.$sdk.api.get("/tag/recent");
        this.recentTags = response.data || [];
      } catch (error) {
        console.error("Error fetching recent tags:", error);
        this.recentTags = [];
      } finally {
        this.loadingRecent = false;
      }
    },
    async fetchPopularTags() {
      try {
        this.loadingPopular = true;
        const response = await this.$sdk.api.get("/tag/popular");
        this.popularTags = response.data || [];
      } catch (error) {
        console.error("Error fetching popular tags:", error);
        this.popularTags = [];
      } finally {
        this.loadingPopular = false;
      }
    },
  },
  props: {
    modelValue: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    createEnabled() {
      return this.$sdk.access.canCreate(this.user, "tag");
    },
    model: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    filteredRecentTags() {
      return this.recentTags.filter((tag) => {
        return !this.model.some((selectedTag) => selectedTag._id === tag._id);
      });
    },
    filteredPopularTags() {
      return this.popularTags.filter((tag) => {
        return !this.model.some((selectedTag) => selectedTag._id === tag._id);
      });
    },
  },
  data() {
    return {
      keywords: "",
      recentTags: [],
      popularTags: [],
      loadingRecent: false,
      loadingPopular: false,
    };
  },
  mounted() {
    // Fetch tags when component is mounted
    this.fetchRecentTags();
    this.fetchPopularTags();
  },
};
</script>
<style scoped>
.tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.panel-content {
  padding: 1em;
}

.pills {
  margin-top: 0.5em;
}

.clickable-tag {
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.clickable-tag:hover {
  opacity: 0.8;
}

.loading,
.no-tags {
  text-align: center;
  padding: 20px;
  color: #666;
  font-style: italic;
}

.loading {
  color: #007bff;
}
</style>
